module.exports = __webpack_public_path__ + "img/feature_yh.94c8543f.gif";